import { ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}


/**
 * Tracks events in Google Analytics
 * @param {string} eventName - The name of the event
 * @param {object} eventParams - Additional event parameters (optional)
 */
export function trackEvent(eventName, eventParams = {}) {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, eventParams)
  }
}

/**
 * Opens the Calendly popup widget and tracks the event
 * @param {string} url - The Calendly URL (default: https://calendly.com/saket-connect/book-a-calll)
 * @param {string} source - The source/location where the button was clicked (optional)
 */
export function openCalendlyPopup(url = 'https://calendly.com/saket-connect/book-a-calll', source = 'unknown') {
  // Track the "Book a Call" click event
  trackEvent('book_a_call_clicked', {
    event_category: 'engagement',
    event_label: source,
    value: 1,
  })

  if (typeof window !== 'undefined' && window.Calendly) {
    window.Calendly.initPopupWidget({ url })
    return false
  } else {
    // Fallback: if Calendly isn't loaded yet, wait a bit and try again
    setTimeout(() => {
      if (window.Calendly) {
        window.Calendly.initPopupWidget({ url })
      }
    }, 100)
    return false
  }
} 